import { allCountries } from 'country-telephone-data'
import memoize from 'memoize-one'

export default memoize(value =>
  allCountries.some(item => `+${item.dialCode}` === value)
)
